export const PUSH_TO_ANCHOR_MENU = 'AnchorMenu/PUSH_TO_ANCHOR_MENU'
export const REMOVE_FROM_ANCHOR_MENU = 'AnchorMenu/REMOVE_FROM_ANCHOR_MENU'
